import InvoicingStatisticsCollection from '~/classes/InvoicingStatisticsCollection';

export const useProfitabilityCards = (profitability: Ref<InvoicingStatisticsCollection | null>) => {
    return computed(() => {
        if (!profitability.value) return [];

        return [
            {
                label: 'invoicing.contact_profitability_panel.total',
                value: Number(profitability.value.getTotal('totalRevenues')) || 0,
                boxColor: 'bg-badgestatus-gray',
                textColor: 'text-statistics-gray',
            },
            {
                label: 'invoicing.contact_profitability_panel.total_paid',
                value: Number(profitability.value.getTotal('revenues')) || 0,
                boxColor: 'bg-badgestatus-green',
                textColor: 'text-statistics-green',
            },
            {
                label: 'invoicing.contact_profitability_panel.total_due',
                value: Number(profitability.value.getTotal('pendingRevenues')) || 0,
                boxColor: 'bg-badgestatus-yellow',
                textColor: 'text-statistics-yellow',
            },
            {
                label: 'invoicing.contact_profitability_panel.total_unpaid',
                value: Number(profitability.value.getTotal('lateRevenues')) || 0,
                boxColor: 'bg-badgestatus-red',
                textColor: 'text-statistics-red',
            },
        ];
    });
};
